<script setup lang="ts">
  import { toActionName } from '@/services/attendance-svc.ts';
  import { useThemeStore } from '@/stores/theme';
  import { PencilSquareIcon, TrashIcon } from '@heroicons/vue/20/solid';
  import dayjs from 'dayjs';

  const props = defineProps<{
    id: number;
    attendanceId: number;
    action: 'WORK_START' | 'WORK_END' | 'AWAY_START' | 'AWAY_END';
    recordDt: string;
  }>();

  const emit = defineEmits<{
    (event: 'update-activity', activityId: number): void;
    (event: 'delete-activity', activityId: number): void;
  }>();

  const badges = {
    WORK_START: 'badge-success',
    WORK_END: 'badge-info',
    AWAY_START: 'badge-warning',
    AWAY_END: 'badge-success',
  } as const;

  const themeStore = useThemeStore();

  function handleUpdateActivity() {
    emit('update-activity', props.id);
  }

  function handleDeleteActivity() {
    confirm('정말 삭제할까요?') && emit('delete-activity', props.id);
  }
</script>
<template>
  <div
    class="w-auto mb-4 card card-compact card-bordered"
    :class="{
      'bg-slate-50 border-slate-200': themeStore.isLight,
      'bg-neutral border-slate-700': themeStore.isDark,
    }">
    <div class="card-body">
      <div>
        <button
          class="btn btn-primary btn-sm btn-circle btn-ghost text-primary align-middle"
          @click="handleUpdateActivity()">
          <PencilSquareIcon class="w-4 h-4" />
        </button>
        {{ dayjs(props.recordDt).format('YYYY-MM-DD HH:mm') }}
        <span
          class="badge ml-2"
          :class="[badges[props.action]]">
          {{ toActionName(props.action) }}
        </span>

        <button
          class="float-right btn btn-sm btn-ghost text-error btn-circle align-middle"
          @click="handleDeleteActivity()">
          <TrashIcon class="w-4 h-4" />
        </button>
      </div>
    </div>
  </div>
</template>
